<template>
   <div class="__container-landing flex min-h-screen flex-col items-center gap-5 pt-20">
      <div class="flex flex-col gap-10">
         <SlideUp>
            <TitleDescription
               center
               description-center
               max-w
               heading="h1"
               title-class="h-xxl"
               :title="$t('web.pages.index.contact-us.title')"
               :description="$t('web.pages.index.contact-us.description')"
            />
         </SlideUp>

         <FadeIn class="rounded-small w-full max-w-lg bg-white p-10">
            <Form v-model="formData" @submit="handleSubmit">
               <TextInput grow v-bind="formData.email" v-model="formData.email.value" />
               <Select grow v-bind="formData.contact_type" v-model="formData.contact_type.value" />
               <TextArea grow v-bind="formData.message" v-model="formData.message.value" />

               <template #footer>
                  <Button grow :loading="loading" type="submit">{{ $t('common.send') }}</Button>
               </template>
            </Form>
         </FadeIn>
      </div>

      <div class="mx-auto">
         <ClientOnly>
            <NuxtTurnstile
               v-model="token"
               :options="{
                  theme: 'light',
               }"
            />
         </ClientOnly>
      </div>
   </div>
</template>

<script lang="ts" setup>
const { t, locale } = useI18n()
const route = useRoute()
const token = ref()
const loading = ref(false)

const notification = useNotification()

const formData = useFormData(() => ({
   email: {
      value: '',
      label: t('form.email'),
      placeholder: t('form.email-placeholder-own'),
      type: 'email' as const,
      required: true,
      validator: isEmail,
   },
   contact_type: {
      value: 'FT_CONTACT',
      label: t('form.contact-form.contact-type'),
      placeholder: t('form.contact-form.contact-type'),
      type: 'select' as const,
      options: [
         { id: 'FT_CONTACT', value: t('enum.FT_CONTACT') },
         { id: 'FT_ERROR', value: t('enum.FT_ERROR') },
      ],
      required: true,
   },
   message: {
      value: '',
      label: t('form.contact-form.message'),
      placeholder: t('form.contact-form.message'),
      type: 'text' as const,
      required: true,
      maxLength: 3000,
   },
}))

const handleSubmit = async (data: typeof formData) => {
   loading.value = true
   await tryCatch(
      async () => {
         await $fetch('/api/form', {
            method: 'POST',
            body: {
               email: data.email.value,
               message: data.message.value,
               token: token.value,
               locale: locale.value || 'it',
               type: data.contact_type.value,
            },
         })
         notification?.add({
            type: 'success',
            title: t('info.success'),
            description: t('info.form-submitted'),
         })
      },
      () => {
         notification?.add({
            type: 'error',
            title: t('error.generic'),
            description: t('error.api.generic-retry'),
         })
      }
   )
   loading.value = false
}

watch(
   () => route.query,
   (curr) => {
      if (curr.type === 'error') {
         formData.contact_type.value = 'FT_ERROR'
      } else {
         formData.contact_type.value = 'FT_CONTACT'
      }
   },
   { immediate: true }
)

useSeo(t('web.seo.index.contact-us.title'), t('web.seo.index.contact-us.description'))
</script>
